import { render } from "./Setting.vue?vue&type=template&id=267fa0e0&scoped=true"
import script from "./Setting.vue?vue&type=script&setup=true&lang=js"
export * from "./Setting.vue?vue&type=script&setup=true&lang=js"

import "./Setting.vue?vue&type=style&index=0&id=267fa0e0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-267fa0e0"],['__file',"src/pages/common/Setting.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "267fa0e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('267fa0e0', __exports__)) {
    console.log('reload')
    api.reload('267fa0e0', __exports__)
  }
  
  module.hot.accept("./Setting.vue?vue&type=template&id=267fa0e0&scoped=true", () => {
    console.log('re-render')
    api.rerender('267fa0e0', render)
  })

}


export default __exports__